export const enum TennisKeyPeriod {
  FINISHED = 'finished',
  GAME_AND_PERIOD = 'gameAndPeriod',
  TIE_BREAK_PERIOD = 'tieBreakPeriod',
  SUPER_TIE_BREAK_PERIOD = 'superTieBreakPeriod',
}

//https://confluence.tennisi.it/pages/viewpage.action?pageId=834961516
export const enum TennisTieBreakTypes {
  TIE_BREAK = 1,
  SUPER_TIE_BREAK_BIG_HELMET = 2,
  SUPER_TIE_BREAK_IN_LAST_SET = 3,
}
